import React, { useState, useEffect } from "react";
import { Menu, Sidebar, Accordion, List, Image } from "semantic-ui-react";

import PLAYLIST from "../constants/playlist";
import AboutComponent from "./about";
import SettingsComponent from "./settings";
import SettingsService from "../services/settingsService";

import "../styles/sidebar.css";

const zeroToNine = [...Array(10).keys()];

export default function SidebarComponent(props) {
  const [selectedVideoId, setSelectedVideoId] = useState(
    SettingsService.getSettings()["currentVideoId"]
  );

  useEffect(() => {
    props.selectedVideoIdChange(selectedVideoId);
    SettingsService.updateSetting({ currentVideoId: selectedVideoId });
  }, [selectedVideoId, props]);

  const calculateActiveIndex = () => {
    const selectedEpisodeNumber = PLAYLIST.find((episode) => {
      return episode["videoId"] === selectedVideoId;
    })["episode"];
    return Math.floor((selectedEpisodeNumber - 1) / 10);
  };

  const generateList = (episodeSlice) => {
    return (
      <List size="medium">
        {episodeSlice.map((episode) => {
          const episodeNumber = episode["episode"];
          const videoId = episode["videoId"];
          return (
            <List.Item
              key={"list" + episodeNumber}
              value={videoId}
              onClick={(e, itemProps) => setSelectedVideoId(itemProps.value)}
              className={selectedVideoId === videoId ? "sidebar-selected" : ""}
            >
              <List.Content>
                <Image floated="left" size="tiny" src={episode["thumbnail"]} />
                <List.Header>
                  {episodeNumber + ": " + episode["title"]}
                </List.Header>
                {episode["translatedTitle"]}
              </List.Content>
            </List.Item>
          );
        })}
      </List>
    );
  };

  const rootPanels = zeroToNine.map((panelNumber) => {
    const episodeSlice = PLAYLIST.slice(
      panelNumber * 10,
      panelNumber * 10 + 10
    );
    const episodeSliceVideoIds = episodeSlice.map(
      (episode) => episode["videoId"]
    );
    return {
      key: "panel" + (panelNumber + 1),
      title: {
        content:
          "Episodes " +
          (panelNumber * 10 + 1) +
          " - " +
          (panelNumber * 10 + 10),
        className: episodeSliceVideoIds.includes(selectedVideoId)
          ? "sidebar-selected"
          : "",
      },
      content: { content: generateList(episodeSlice) },
    };
  });

  return (
    <Sidebar
      as={Menu}
      animation="overlay"
      vertical
      width="wide"
      visible={props.visbility}
    >
      <AboutComponent />
      <SettingsComponent />
      <Accordion
        defaultActiveIndex={calculateActiveIndex()}
        panels={rootPanels}
      />
    </Sidebar>
  );
}
